

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop, Watch} from "vue-property-decorator";
  import {
    E_SERVICE_PROVIDER_TAG_TYPES,
    EServiceProviderType,
    IServiceProvider
  } from "@/model/Service/serviceProviderInterfaces";
  import {IErrors} from "@/model/IErrors";
  import V2SpFormCardLayout from "@/components/serviceProvider/v2/layouts/V2SpFormCardLayout.vue";

  @Component({
    computed: {
      E_SERVICE_PROVIDER_TAG_TYPES() {
        return E_SERVICE_PROVIDER_TAG_TYPES
      }
    },
    components: {V2SpFormCardLayout}
  })
  export default class SPTranslatableContent extends Vue {

    @Prop()
    public provider!: IServiceProvider;
    @Prop()
    public errors!: IErrors;
    @Prop()
    public editing!: boolean;
    @Prop()
    public viewing!: boolean;
    @Prop()
    public submitting!: boolean;

    @Prop({ default: () => [] })
    public emptyDescriptions!: string[];

    @Prop({ type: Boolean, default: false })
    public submitted!: boolean;

    public tab: any = null;
    public localViewing: boolean = false;

    public get isInfoCard(): boolean {
      return this.provider.type == EServiceProviderType.infocard || this.provider.type == EServiceProviderType.infocard_sending;
    }

    public get showDetails(): boolean {
      return this.editing || this.viewing || this.localViewing;
    }

    public get localeItems(): string[] {
      return Object.keys(this.provider.about_us);
    }

    public get missingFieldsList(): string[] {
      if (!this.submitted) return [];
      const missing: string[] = [];
      for (const locale of this.localeItems) {
        if (!this.provider.primary_service_description[locale]) {
          missing.push(`${this.$t('services.provider.fields.primary_service_description')} (${locale})`);
        }
        if (!this.provider.about_us[locale]) {
          missing.push(`${this.$t('services.provider.fields.about_us')} (${locale})`);
        }
      }
      return missing;
    }

    public fieldError(locale: string, fieldKey: 'primary_service_description' | 'about_us'): string[] {
      if (!this.submitted) return [];
      const field = this.provider[fieldKey] as Record<string, string>;
      if (!field[locale]) return [this.$t('common.required') as string];
      return [];
    }

    public onExpand() {
      this.localViewing = true;
    }

    public sectionIsEmpty(locale: string) {
      return this.emptyDescriptions.includes(locale);
    }
  }
